import { OrderLabelEnum } from 'src/interfaces';

import { COMMON_GCF_COMPONENT_CONFIG } from './gcfComponentCommonConfig';

export const GCF_COMBO_STYLE_CONFIG = {
  ...COMMON_GCF_COMPONENT_CONFIG,
  productList: {
    config: {
      visuals: {
        items: [],
      },
      badges: {
        itemBadge: {
          type: OrderLabelEnum.alphabet,
        },
      },
    },
  },
  flavor: {
    visible: false,
  },
};
